import React from 'react';

import BlinkoGame from './BlinkoGame';
import { AssetHandler } from './components/AssetHandler';
import { SoundHandler } from './components/SoundHandler';
import { MetadataHandler } from './components/MetadataHandler';
import { PlayResultHandler } from './components/PlayResultHandler';
import { NotificationHandler } from './components/NotificationHandler';

interface GamePageProps {
  isIgamingDemo?: boolean;
}

const GamePage: React.FC<GamePageProps> = ({ isIgamingDemo = false }) => {
  return (
    <AssetHandler>
      <SoundHandler />
      <MetadataHandler />
      <NotificationHandler />
      <PlayResultHandler />
      <BlinkoGame isIgamingDemo={isIgamingDemo} />
    </AssetHandler>
  );
};

export default GamePage;
